<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>设备</el-breadcrumb-item>
      <el-breadcrumb-item>数据维护</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
          @submit.native.prevent
        >
          <div class="filter-block">
            <el-form-item label="设备号" prop="query">
              <el-input
                size="small"
                v-model="filter.query"
                autocomplete="off"
                @keyup.enter.native="reqeustDevices()"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="mt-10 flex-row-between">
          <div>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1;
                reqeustDevices();
              "
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <div class="header flex-row-between">
        <div></div>
        <file-button
          class="mobile-hide"
          obj="customer_device_batch"
          :filter="filter"
          @importCallback="reset"
        ></file-button>
      </div>
      <el-table :data="devices" v-loading="loading" class="mt-10">
        <el-table-column prop="equipment_number" label="设备号">
        </el-table-column>
        <el-table-column prop="machine_type" label="包含机型" min-width="200">
          <template slot-scope="scope">
            <el-tag
              type="primary"
              size="mini"
              class="mr-5 mb-5"
              v-for="item in scope.row.machine_types"
              :key="item"
              >{{ item || '无' }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="machine_type"
          label="包含机型分类"
          min-width="200"
        >
          <template slot-scope="scope">
            <el-tag
              type="primary"
              size="mini"
              class="mr-5 mb-5"
              v-for="item in scope.row.item_categories"
              :key="item"
              >{{ item.split(',').join(' - ') || '无' }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="描述" min-width="200">
          <template slot-scope="scope">
            <el-tag
              type="primary"
              size="mini"
              class="mr-5 mb-5"
              v-for="item in scope.row.descriptions"
              :key="item"
              >{{ item.split(',').join(' - ') || '无' }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="device_count" label="数量" align="center">
        </el-table-column>
        <el-table-column align="right" label="操作" class-name="mobile-hide">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              plain
              @click="batchEdit(scope.row, scope.$index)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <Former
      :model="customerDeviceForm"
      :show.sync="createCustomerDeviceFormVisible"
      @updated="updatedCallback"
    ></Former>
  </div>
</template>

<script>
import { customerDeviceGroupList } from '@/service/getData';
import { clone } from '@/util';
import Former from './former.vue';
export default {
  components: {
    Former,
  },
  data() {
    return {
      filter: {
        query: '',
        size: 20,
        page: 1,
      },
      total: 0,
      devices: [],
      loading: false,
      customerDeviceForm: {},
      editDeviceIndex: 0,
      createCustomerDeviceFormVisible: false,
    };
  },
  watch: {
    'filter.page': function() {
      this.reqeustDevices();
    },
  },
  created() {
    this.filter = {
      page: parseInt(this.$route.query.page || 1),
      size: parseInt(this.$route.query.size || 20),
      query: this.$route.query.query || '',
    };
    this.reqeustDevices();
  },
  methods: {
    async reqeustDevices() {
      this.$router.replace({
        query: this.filter,
      });

      this.loading = true;
      let data = clone(this.filter);
      data.page--;

      let res = await customerDeviceGroupList(data);
      if (res.code == 0) {
        let list = res.data.list.map((item) => {
          let machine_types = item.group_machine_type.split('|') || [];
          let item_categories = item.group_item_category.split('|') || [];
          let descriptions = item.group_description.split('|') || [];

          if (machine_types.length > 3) {
            machine_types = machine_types.slice(0, 3);
            machine_types.push('...');
          }

          if (descriptions.length > 3) {
            descriptions = descriptions.slice(0, 3);
            descriptions.push('...');
          }

          if (item_categories.length > 3) {
            item_categories = item_categories.slice(0, 3);
            item_categories.push('...');
          }

          if (item.customer_id == 0) {
            item.device_count =
              item.device_count == 1 ? 0 : item.device_count - 1;
          }

          let item_category_ids = item.group_item_category_ids.split('|') || [];

          return {
            id: item.id,
            equipment_number: item.equipment_number,
            device_count: item.device_count,
            machine_types: machine_types,
            descriptions: descriptions,
            item_categories: item_categories,
            item_category_id:
              item_category_ids.length > 0 ? parseInt(item_category_ids[0]) : 0,
          };
        });
        this.devices = list;
        this.total = res.data.total;
        this.queryData = data;
      }
      this.loading = false;
    },
    batchEdit(device, index) {
      this.createCustomerDeviceFormVisible = true;
      this.editDeviceIndex = index;
      this.customerDeviceForm = {
        id: device.id,
        equipment_number: device.equipment_number,
        item_category_id: device.item_category_id,
        machine_type: device.machine_types[0] || device.machine_types[1],
        description: device.descriptions[0] || device.descriptions[1],
      };
    },
    updatedCallback(e) {
      this.devices[this.editDeviceIndex].machine_types = [e.machine_type];
      this.devices[this.editDeviceIndex].descriptions = [e.description];
      this.devices[this.editDeviceIndex].item_categories = [
        e.item_category_name,
      ];
      this.devices[this.editDeviceIndex].item_category_id = e.item_category_id;
      this.$message.success(`数据更新成功`);
    },
    reset() {
      this.filter = {
        query: '',
        size: 20,
        page: 1,
      };
      this.reqeustDevices();
    },
  },
};
</script>

<style scoped>
.confirm-content div {
  font-size: 12px;
  margin-top: 5px;
  color: #555;
}
.sap-code-tag {
  display: inline-block;
  padding: 0px 3px;
  border-radius: 3px;
  font-size: 12px;
  background-color: #eee;
}

.customer-tags .el-tag {
  margin-right: 5px;
}
</style>

<style>
.warning-row {
  background: rgb(255, 250, 241);
}
</style>
